// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class SelfStudyResponseType {
    public static readonly INSTRUCTOR: number = 1;
    public static readonly RPP: number = 2;
    public static readonly DOE: number = 3;
}
